class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.timer = null;
    
    this.addEventListener('mouseenter', () => this.onMouseEnter());

    const parentNav = this.closest('nav');
    if (parentNav && !parentNav.dataset.hoverInitialised) {
      parentNav.dataset.hoverInitialised = 'true';
      
      // close menu when mouse leave nav
      parentNav.addEventListener('mouseleave', () => {
        this.timer = setTimeout(() => {
          if (!parentNav.matches(':hover')) {
            parentNav.querySelectorAll('header-menu').forEach(menu => menu.close());
          }
        }, 200);
      });

      // close menu when hover on link not have submenu
      parentNav.querySelectorAll('a.header__menu-item:not(summary)').forEach(link => {
        link.addEventListener('mouseenter', () => {
          parentNav.querySelectorAll('header-menu').forEach(menu => menu.close());
        });
      });
    }

    this.querySelectorAll('details').forEach((details) => {
      details.addEventListener('mouseenter', () => {
        if (this.timer) clearTimeout(this.timer);
        details.setAttribute('open', '');
        details.querySelector('summary').setAttribute('aria-expanded', true);
      });
      details.addEventListener('mouseleave', () => {
        if (details !== this.mainDetailsToggle) {
          details.removeAttribute('open');
          details.querySelector('summary').setAttribute('aria-expanded', false);
        }
      });
    });
  }

  onMouseEnter() {
    const parentNav = this.closest('nav');
    if (parentNav) {
      parentNav.querySelectorAll('header-menu').forEach(menu => {
        if (menu !== this) menu.close();
      });
    }

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
